import { lazy, Suspense, type ComponentProps, type FC } from "react";
import { SkeletonBlock } from "@/components/podkit/loading/Skeleton";
import { ErrorBoundary } from "react-error-boundary";
import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";

const MuxPlayer = lazy(() => import("@mux/mux-player-react"));

type VideoSectionProps = {
    playbackId: string;
    metadataVideoTitle: string;
    poster?: string;
    onPlay?: () => void;
    style?: React.CSSProperties & Record<string, string>;
} & ComponentProps<typeof MuxPlayer>;

export const VideoSection: FC<PropsWithClassName<VideoSectionProps>> = ({
    playbackId,
    metadataVideoTitle,
    poster,
    className,
    onPlay,
    style,
    ...props
}) => (
    <div
        className={cn(
            "flex w-full flex-col items-start justify-start overflow-hidden rounded-md drop-shadow-xl",
            className,
        )}
    >
        <ErrorBoundary fallback={<SkeletonBlock failed={true} ready={false} className="aspect-video w-full" />}>
            <Suspense fallback={<SkeletonBlock ready={false} className="aspect-video w-full" />}>
                <MuxPlayer
                    aria-label={"Video: " + metadataVideoTitle}
                    streamType="on-demand"
                    playbackId={playbackId}
                    metadataVideoTitle={metadataVideoTitle}
                    primaryColor="#FFFFFF"
                    secondaryColor="#000000"
                    accentColor="#FF8A00"
                    defaultHiddenCaptions={true}
                    poster={poster}
                    onPlay={onPlay}
                    disableTracking={true}
                    style={{
                        aspectRatio: 16 / 9,
                        backgroundColor: "var(--surface-tertiary)",
                        borderRadius: "6px",
                        ...style,
                    }}
                    {...props}
                />
            </Suspense>
        </ErrorBoundary>
    </div>
);
